import React, { useMemo } from 'react'
import {
  ListItemText, ListItem, Typography, Collapse, List,
} from '@material-ui/core'
import { cx } from 'linaria'
import { MenuCategoryTab, MenuItem, SubMenuColumn } from '../Header'
import {
  ExpandMore, ExpandLess,
} from '@material-ui/icons'
import { useRouter } from 'next/router'
import classes from './MobileHeader.styles'
import theme, { COLORS } from '../../../styles/theme'

interface MobileMenuItemProps {
  item: MenuItem;
  index: number;
  handleSubMenuClick: (i: number) => void;
  handleSubMenuChildClick: () => void;
  openSubMenuIndexes: number[]
  activeCategory: MenuCategoryTab;
}

export default function MobileMenuItem({
  item,
  index,
  handleSubMenuClick,
  handleSubMenuChildClick,
  openSubMenuIndexes,
  activeCategory
}: MobileMenuItemProps) {
  const submenuItems = item.sub_menu_items ?? []

  const columns: SubMenuColumn[] = useMemo(() => {
    if (activeCategory?.sub_menu_columns?.length) {
      return activeCategory.sub_menu_columns.filter(
        col =>
          col.main_menu_element?.trim().toLowerCase() ===
          item.title?.trim().toLowerCase()
      )
    }
    return []
  }, [activeCategory, item.title])

  const hasColumns = columns.length > 0
  const hasSubItems = submenuItems.length > 0
  const hasItems = hasSubItems || hasColumns

  const router = useRouter()
  const currentPath = router.asPath
  const { slug } = router.query
  const currentSlug = slug ? `/${slug[0]}` : ''

  const isMainActive = item.url === currentPath
  const isSubActive = submenuItems.some(sub => sub.url === currentSlug)


  
const currentSubMenuIsOpen = openSubMenuIndexes.includes(index)

  const itemClass = cx(
    classes.item,
    !hasItems && isMainActive ? classes.activeItem : '',
    hasItems && (isMainActive || isSubActive) ? classes.activeItem : '',
  )

  const handleMainItemClick = () => {
    if (item.url === currentPath) {
      return handleSubMenuClick(index)
    }

    return item.url && router.push(item.url)
  }

  if (!hasItems) {
    return (
      <ListItem
        button
        className={itemClass}
        href={item.url ?? '#'}
        style={{
          marginBottom:16,

        }}
        component="a"
      >
        <ListItemText
          disableTypography
          primary={
            <>
              {item.icon && <img src={item.icon} alt="" />}
              <Typography variant="body1" component="div" style={{fontSize:18}} >
                {item.title}
              </Typography>
            </>
          }
        />
      </ListItem>
    )
  }

  return (
    <>
      <ListItem
        button
        className={itemClass}
        style={{
          marginBottom:16,
          position: 'sticky',
          width: '100%',
          boxSizing: 'border-box',
          top: 0,
          zIndex: 10,
          backgroundColor:COLORS.smoke,
          transition:'none'
        }}
        onClick={handleMainItemClick}
      >
        <ListItemText
          disableTypography
          primary={
            <>
              {item.icon && <img src={item.icon} alt="" />}
              <Typography variant="body1" component="div" style={{fontSize:18}} >
                {item.title}
              </Typography>
            </>
          }
        />
        <div className={classes.subMenuIcon}>
          {currentSubMenuIsOpen ? (
            <ExpandLess
              onClick={(e) => {
                e.stopPropagation()
                handleSubMenuClick(index)
              }}
              fontSize="small"
            />
          ) : (
            <ExpandMore
              onClick={(e) => {
                e.stopPropagation()
                handleSubMenuClick(index)
              }}
              fontSize="small"
            />
          )}
        </div>
      </ListItem>

      {hasItems && (
        <Collapse in={currentSubMenuIsOpen} unmountOnExit>
          {hasColumns ? (
            <div >
              {columns
                .sort((a, b) => a.order_in_the_queue - b.order_in_the_queue)
                .map((column, colIdx) => (
                  <div key={colIdx} >
                    {column.title && (
                      <Typography
                       color="primary"
                      style={{ fontWeight: 600,fontSize:14, marginBottom: column.title ? 16 : 0 , padding:theme.spacing(0,0,0,7)}}
                      variant="h5"
                      >
                        {column.title}
                      </Typography>
                    )}
                    {column.sub_menu_items.map((subItem, subIndex) => {
                      const isCurrentSlug = subItem.url === currentSlug
                      const subItemClass = cx(
                        classes.item,
                        isCurrentSlug ? classes.activeSubItem : ''
                      )

                      return (
                        <ListItem
                          key={`${colIdx}-${subIndex}`}
                          button
                          href={subItem.url ?? '#'}
                          className={subItemClass}
                          style={{ padding:theme.spacing(0,2,2,11)}}
                          component="a"
                          onClick={
                            subItem.modal
                              ? (event: React.MouseEvent) => {
                                  event.stopPropagation()
                                  router.push(
                                    `${router.asPath}${subItem?.url}`,
                                    undefined,
                                    { shallow: true }
                                  )
                                }
                              : handleSubMenuChildClick
                          }
                        >
                          <ListItemText
                            disableTypography
                            primary={
                              <Typography variant="body2" style={{fontWeight:400}}>
                                {subItem.title}
                              </Typography>
                            }
                          />
                        </ListItem>
                      )
                    })}
                  </div>
                ))}
            </div>
          ) : (
            <List className={classes.subMenuItem}>
              {submenuItems.map((subItem, subIndex) => {
                const isCurrentSlug = subItem.url === currentSlug
                const subItemClass = cx(
                  classes.item,
                  isCurrentSlug ? classes.activeSubItem : ''
                )

                return (
                  <ListItem
                    key={subIndex}
                    button
                    href={subItem.url ?? '#'}
                    className={subItemClass}
                    component="a"
                    onClick={
                      subItem.modal
                        ? (event: React.MouseEvent) => {
                            event.stopPropagation()
                            router.push(
                              `${router.asPath}${subItem?.url}`,
                              undefined,
                              { shallow: true }
                            )
                          }
                        : handleSubMenuChildClick
                    }
                  >
                    <ListItemText
                      disableTypography
                      primary={
                        <Typography variant="overline">
                          {subItem.title}
                        </Typography>
                      }
                    />
                  </ListItem>
                )
              })}
            </List>
          )}
        </Collapse>
      )}
    </>
  )
}
